// @flow

/**
 * Breakpoints are ported from foundation-sites/scss/util/util.
 */
class BREAKPOINTS {
  // a/b portal
  static XSMALL: string = '375px';
  static SMALL: string = '480px';
  static MEDIUM: string = '640px';
  // a/b portal
  static MEDIUM_LARGE_S: string = '764px';
  static MEDIUM_LARGE: string = '850px';
  static LARGE: string = '1024px';
  static XLARGE: string = '1200px';
  static XXLARGE: string = '1440px';
}

export default BREAKPOINTS;
